var React = require('react');

function DescBgTriangles (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M175.133 66.6592L112.908 60.3292M175.133 66.6592L141.888 83.3077M175.133 66.6592L127.983 108.177M112.908 60.3292L141.888 83.3077M112.908 60.3292L127.983 108.177M141.888 83.3077L127.983 108.177","stroke":"#553E6B","key":0}),React.createElement("path",{"d":"M42.2578 1.4834L1.82539 13.6872M42.2578 1.4834L25.5911 17.9937M42.2578 1.4834L23.0313 33.8299M1.82539 13.6872L25.5911 17.9937M1.82539 13.6872L23.0313 33.8299M25.5911 17.9937L23.0313 33.8299","stroke":"#553E6B","key":1})]);
}

DescBgTriangles.defaultProps = {"width":"177","height":"117","viewBox":"0 0 177 117","fill":"none"};

module.exports = DescBgTriangles;

DescBgTriangles.default = DescBgTriangles;
